
import { Card, CardBody, Flex, Image, Text, useColorMode } from '@chakra-ui/react'
import Heading from '../heading'

interface IconCardProps {
  className?: string,
  icon?: string,
  title?: string,
  description?: string
}

function IconCard(props: IconCardProps) {

  const {
    icon,
    title,
    description
  } = props

  const { colorMode } = useColorMode()
  const isLight = colorMode === 'light'

  return (
    <Card
      w="full"
      bg={isLight ? 'white' : 'darkNavy'}
      borderWidth={1}
      borderStyle="solid"
      borderColor={isLight ? 'border' : '#0E1A56'}
      borderRadius={14}
      boxShadow="none"
    >
      <CardBody pt="30px" px="25px" pb="30px">
        <Flex flexDirection="column" alignItems="center" gap="10px">
          <Image src={icon} alt={title}/>
          <Flex
            flexDirection="column"
            alignItems="center"
            color={isLight ? 'midnightBlue' : 'white'}
            textAlign="center"
          >
            <Heading as="h5">{title}</Heading>
            <Text size="xs" lineHeight="20px">{description}</Text>
          </Flex>
        </Flex>
      </CardBody>
    </Card>
  )
}

export default IconCard